import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth.service';
import { User } from '../../models/user.model';
import { LoggerService } from '../../services/logger.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  modo: 'login' | 'register' = 'login'; 
  loginForm: FormGroup;
  registerForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private logger: LoggerService) {
      
      this.loginForm = this.fb.group({
        username: ['', [Validators.required]],
        password: ['', Validators.required]
      });

      this.registerForm = this.fb.group({
        nombre: ['', [Validators.required]], // NUEVO
        username: ['', [Validators.required, Validators.email]], // Es el email realmente
        password: ['', [Validators.required, Validators.minLength(6)]],
        passwordConfirm: ['', Validators.required]
      });
    }

  ngOnInit(): void {
    this.logger.log("LoginComponent.ngOnInit.");
    
    this.route.queryParams.subscribe(params => {
        const token = params['token'];
        const userEncoded = params['user'];

        if (token && userEncoded) {
          this.authService.setAccessToken(token);

          try {
            const userObject = JSON.parse(decodeURIComponent(userEncoded));
            
            const currentUser = new User(
              userObject.id,
              userObject.username || userObject.nombre || '',
              '', 
              userObject.email,
              userObject.createdat || new Date().toISOString(), 
              userObject.consumedtokens,
              userObject.totaltokens,
              userObject.tenantid,
              userObject.issuperadmin
            );

            this.authService.setCurrentUser(currentUser); 

            this.authService.loadMyPermissions().subscribe({
              next: () => {
                this.logger.log('Permisos cargados correctamente desde Google Auth');
                this.router.navigate(['/app/home']);
              },
              error: (err) => {
                this.logger.error('Error cargando permisos', err);
                this.router.navigate(['/app/home']); 
              }
            });

          } catch (e) {
            this.logger.error("Error al parsear el usuario", e);
          }
        }
        if (params['error'] === 'usuario_no_registrado') {
          this.logger.error("Error login: Usuario no registrado");
        }
    });

    this.route.queryParams.subscribe(params => {
      this.modo = params['modo'] === 'register' ? 'register' : 'login';
    });
  }

  onSubmitLogin(): void {
    if (this.loginForm.valid) {
      const { username, password } = this.loginForm.value;

      this.authService.login(username, password).subscribe({
        next: (response) => {
          this.logger.log('Login successful', response);

          this.authService.loadMyPermissions().subscribe(() => {
            this.router.navigate(['/app/home']);
          });
        },
        error: (httpError) => {
          this.logger.error('Login failed', httpError);
          
          if (httpError.status === 429) {
            alert(httpError.error?.message || 'Demasiados intentos. Por favor, espera 15 minutos.');
          } else if (httpError.status === 401 || httpError.status === 400) {
            alert(httpError.error?.message || 'Usuario o contraseña incorrectos.');
          } else {
            alert('Error interno del servidor. Contacte con soporte.');
          }
        }
      });
    }
  }

  onSubmitRegister(): void {
    if (this.registerForm.valid) {
      const { nombre, username, password, passwordConfirm } = this.registerForm.value;

      if (password !== passwordConfirm) {
        alert('Las contraseñas no coinciden.');
        return;
      }

      this.authService.requestAccess(nombre, username, password).subscribe({
        next: (res) => {
          this.logger.log('Registro exitoso (pendiente de aprobación)', res);
          alert('Solicitud enviada correctamente. Un administrador revisará tu cuenta.');
          this.registerForm.reset();
          
          // Cambiamos a la vista de login limpiando la URL
          this.router.navigate([], { queryParams: { modo: null }, queryParamsHandling: 'merge' });
          this.modo = 'login';
        },
        error: (httpError) => {
          this.logger.error('Error en registro', httpError);
          alert(httpError.error?.message || 'Error al procesar la solicitud.');
        }
      });
    }
  }

  onLoginWithGoogle(): void {
    window.location.href = environment.api_service_auth_google;
  }

  cancelar(): void {
    this.router.navigate(['/']);
  }
}